import React from 'react';
import { NavLink } from 'react-router-dom';
import imgCamera from '../../assets/images/icons/camera.svg';
import styles from './case.module.scss';

const NumberCase = ({
  selectedCase,
  currentFolder,
  searchParams,
  openPictureFolder,
}) => {
  // Normaliser un numéro pour comparaison (cohérent avec RootCase)
  function normalizeNumber(num) {
    if (num == null || num === '' || num === 'Sans numéro') return String(num ?? '');
    return String(num).trim().replace(/\s+/g, '').replace(/-/g, '');
  }

  // Helper function pour vérifier si une image correspond
  // au numéro sélectionné (ou au piecePL si fourni, ex. document lié à une LL)
  function matchesNumber(picture, selectedNumber, piecePL) {
    if (selectedNumber === 'Sans numéro') {
      return (
        !picture.number
        || picture.number === null
        || picture.number === undefined
        || picture.number === ''
        || picture.number === 'Sans numéro'
      );
    }
    const matchNumber = normalizeNumber(picture.number) === normalizeNumber(selectedNumber);
    const matchPiecePL = piecePL && normalizeNumber(picture.number) === normalizeNumber(piecePL);
    return matchNumber || matchPiecePL;
  }

  // Préparation : taskType 'Préparation' ou sans taskType avec type 'departure'
  function isPreparationPicture(p) {
    return p.taskType === 'Préparation' || (!p.taskType && p.type === 'departure');
  }

  // Déchargement : taskType 'Déchargement' ou sans taskType avec type 'return'
  function isDechargementPicture(p) {
    return p.taskType === 'Déchargement' || (!p.taskType && p.type === 'return');
  }

  // Un seul élément par file._id (aligné avec PictureCase)
  function uniquePicturesByFileId(pictures) {
    const seen = new Set();
    return (pictures || []).filter((p) => {
      const id = p.file?._id;
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }

  return (
    <>
      <div className={styles.breadcrumbTrail}>
        <p>
          <NavLink key={`root-${currentFolder._id}`} to={`/case/${selectedCase._id}`}>...</NavLink>
          <span> / {searchParams.get('number')}</span></p>
      </div>
      <div className={styles.pictures}>
        {uniquePicturesByFileId(currentFolder.pictures.filter((p) => matchesNumber(p, searchParams.get('number'), searchParams.get('piecePL')) && isPreparationPicture(p))).length > 0 && (
          <div className={styles.tile} onClick={() => openPictureFolder('Préparation')}>
            <div className={styles.icon}>
              <img src={imgCamera} alt="photos préparation" />
            </div>
            <div className={styles.count}>
              <p>Photos préparation</p>
              <p>{uniquePicturesByFileId(currentFolder.pictures.filter((p) => matchesNumber(p, searchParams.get('number'), searchParams.get('piecePL')) && isPreparationPicture(p))).length}</p>
            </div>
          </div>
        )}
        {uniquePicturesByFileId(currentFolder.pictures.filter((p) => matchesNumber(p, searchParams.get('number'), searchParams.get('piecePL')) && p.taskType === 'Chargement')).length > 0 && (
          <div className={styles.tile} onClick={() => openPictureFolder('Chargement')}>
            <div className={styles.icon}>
              <img src={imgCamera} alt="photos chargement" />
            </div>
            <div className={styles.count}>
              <p>Photos chargement</p>
              <p>{uniquePicturesByFileId(currentFolder.pictures.filter((p) => matchesNumber(p, searchParams.get('number'), searchParams.get('piecePL')) && p.taskType === 'Chargement')).length}</p>
            </div>
          </div>
        )}
        {uniquePicturesByFileId(currentFolder.pictures.filter((p) => matchesNumber(p, searchParams.get('number'), searchParams.get('piecePL')) && isDechargementPicture(p))).length > 0 && (
          <div className={styles.tile} onClick={() => openPictureFolder('Déchargement')}>
            <div className={styles.icon}>
              <img src={imgCamera} alt="photos déchargement" />
            </div>
            <div className={styles.count}>
              <p>Photos déchargement</p>
              <p>{uniquePicturesByFileId(currentFolder.pictures.filter((p) => matchesNumber(p, searchParams.get('number'), searchParams.get('piecePL')) && isDechargementPicture(p))).length}</p>
            </div>
          </div>
        )}
        {/* uniquePicturesByFileId(currentFolder.pictures.filter((p) => (
          matchesNumber(
            p,
            searchParams.get('number'),
            searchParams.get('piecePL')
          ) && p.taskType === 'Retour')).length > 0
         ) && (
          <div className={styles.tile} onClick={() => openPictureFolder('Retour')}>
            <div className={styles.icon}>
              <img src={imgCamera} alt="photos retour" />
            </div>
            <div className={styles.count}>
              <p>Photos retour</p>
              <p>{
                uniquePicturesByFileId(currentFolder.pictures.filter((p) => (
                  matchesNumber(
                    p,
                    searchParams.get('number'),
                    searchParams.get('piecePL')
                  ) && p.taskType === 'Retour')).length
                )
              }</p>
            </div>
          </div>
        ) */}
        {uniquePicturesByFileId(currentFolder.pictures.filter((p) => matchesNumber(p, searchParams.get('number'), searchParams.get('piecePL')) && p.type === 'hs')).length > 0 && (
          <div className={styles.tile} onClick={() => openPictureFolder('hs')}>
            <div className={styles.icon}>
              <img src={imgCamera} alt="photos hs" />
            </div>
            <div className={styles.count}>
              <p>Photos hs et reparation</p>
              <p>{uniquePicturesByFileId(currentFolder.pictures.filter((p) => matchesNumber(p, searchParams.get('number'), searchParams.get('piecePL')) && p.type === 'hs')).length}</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default NumberCase;
